import React, { useState, useEffect, useMemo } from "react";
import { Button, Modal } from "react-bootstrap";
import RegistrasiService from "../../../services/registrasi/RegistrasiService";

const ModalImg = ({ showImg, handleCloseImg, setJenisImg, setKdDokumen }) => {

  const [linkFile, setLinkFile] = useState("");
  let RegService = useMemo(() => new RegistrasiService(), []);

  useEffect(() => {
    getImage();
  }, [setJenisImg, setKdDokumen]);

  const getImage = async (jnsImg, kdDok) => {
    try {
      const resDok = await RegService.getDokumen(setJenisImg, setKdDokumen)
      if (resDok.data === null) {
        return;
      }
      setLinkFile(resDok.data.DOK_PATH)
    } catch (error) {
      console.log(error);
    }
  };

  const handleBatal = () => {
    handleCloseImg();
  };

  return (
    <>
      <Modal
        show={showImg}
        onHide={handleCloseImg}
        backdrop="static"
        keyboard={false}
        scrollable={true}
        size="xl"
        centered
      >
        <Modal.Header>
          <h6>{setKdDokumen === 1 ? "NPWP" : setKdDokumen === 2 ? "NO IDENTITAS" : "NIB"}</h6>
        </Modal.Header>
        <Modal.Body>
          {linkFile !== undefined && linkFile.substring(linkFile.length - 3) === "pdf" ? (
            <iframe src={linkFile} width="100%" height="500" allowFullScreen></iframe>
          ) : (
            <img src={linkFile} width="100%" />
          )}
          {linkFile}
        </Modal.Body>
        <Modal.Footer>
          <Button variant="danger" size="sm" onClick={() => handleBatal()}>
            Close
          </Button>
        </Modal.Footer>
      </Modal>
    </>
  );
};

export default ModalImg;
